import {
  Box,
  Flex,
  HStack,
  Spinner,
  Stack,
  Tab,
  TabList,
  TabPanel,
  TabPanels,
  Tabs,
} from '@chakra-ui/react';
import React, { useEffect, useState } from 'react';
import { FiSearch } from 'react-icons/fi';
import { Text } from '@chakra-ui/layout';
import { Heading, Input, Pagination, ReactSelect } from '~/components';
import { useCompanyGroupsAsSelect, useRoleCan } from '~/hooks';
import { SelectItem } from '~/types';
import { MachineParkForm } from '~/pages/Portal/StrategicMap/MachineParkForm';
import { MachinePark } from '~/pages/Portal/StrategicMap/MachinePark';
import { useFeatureFlags } from '~/contexts/FeatureFlagsContext/FeatureFlagsContext';
import { StrategicMapContracts } from '~/pages/Portal/StrategicMap/StrategicMapContracts';
import { useGroupContracts } from '~/hooks/useStrategicMap';

export const StrategicMap: React.VFC = () => {
  const featureflags = useFeatureFlags();

  const podeCadastrar = useRoleCan({
    roles: ['administrador', 'gerente de contas'],
  });
  const [grupoeconomico, setGrupoeconomico] = useState<SelectItem | undefined>(
    undefined,
  );
  const {
    data: groupsList,
    isLoading: isGroupsLoading,
    refetch: refechGroups,
  } = useCompanyGroupsAsSelect(
    {
      onSuccess: r => {
        if (r.length) {
          const urlParams = new URLSearchParams(window.location.search);
          const param = urlParams.get('grupoeconomico');
          const gp = r.find(g => g.value === param) || r[0];
          setGrupoeconomico(gp);
        }
      },
    },
    9999,
  );

  const [searchTmp, setSearchTmp] = useState('');
  const [page, setPage] = useState(1);
  const [pageSize, setPageSize] = useState('10');

  const {
    data: contratos,
    isLoading: isLoadingContratos,
    isError: isErrorContratos,
    isFetching: isFetchingContratos,
  } = useGroupContracts(
    Number(grupoeconomico?.value),
    searchTmp,
    page,
    pageSize,
  );

  useEffect(() => {
    refechGroups();
  }, []);

  function handleGroup(e?: SelectItem) {
    setGrupoeconomico(e);
    setPage(1);
    setPageSize('10');
    updateUrlParams(Number(e?.value));
  }

  const updateUrlParams = (idGroup: number) => {
    const urlParams = new URLSearchParams();
    urlParams.set('grupoeconomico', String(idGroup));
    window.history.pushState(
      {},
      '',
      `${window.location.pathname}?${urlParams}`,
    );
  };

  return (
    <Box px="8" py="4">
      <Heading>Mapa estratégico do cliente</Heading>
      <Flex pt={2} flexDir="column" w="100%">
        <Flex justify="space-between" py={5}>
          <Flex align="center" gridGap={4} w="400px" zIndex={9999}>
            <ReactSelect
              name="grupoeconomico"
              isSearchable
              label="Grupo econômico"
              options={groupsList}
              value={grupoeconomico}
              defaultStyle
              onChange={e => handleGroup(e as SelectItem)}
              isDisabled={isGroupsLoading}
              placeholder="Selecione"
            />
          </Flex>
          {featureflags.parqueMaquinasEnabled && podeCadastrar && (
            <HStack
              gridGap={2}
              justifyContent="space-between"
              alignItems="baseline"
              isDisabled={!grupoeconomico || !grupoeconomico.value}
            >
              <MachineParkForm grupo={grupoeconomico} />
            </HStack>
          )}
        </Flex>
      </Flex>
      <Stack mt="30px">
        {(featureflags.parqueMaquinasEnabled ||
          featureflags.mapaEstrategicoContratosEnabled) && (
          <Tabs variant="enclosed">
            <TabList>
              {featureflags.parqueMaquinasEnabled && (
                <Tab fontWeight="bold">Parque de Máquinas</Tab>
              )}
              {featureflags.mapaEstrategicoContratosEnabled && (
                <Tab fontWeight="bold">Contratos</Tab>
              )}
            </TabList>
            <TabPanels>
              {featureflags.parqueMaquinasEnabled && (
                <TabPanel>
                  <MachinePark grupoeconomico={grupoeconomico} />
                </TabPanel>
              )}
              {featureflags.mapaEstrategicoContratosEnabled && (
                <TabPanel>
                  <Stack gridGap={2}>
                    <Input
                      name="search"
                      type="text"
                      icon={FiSearch}
                      value={searchTmp}
                      onChange={e => {
                        setPage(1);
                        setSearchTmp(e.target.value);
                      }}
                      placeholder="Procure por contrato e termo"
                      w={450}
                      fontSize="15px"
                    />
                    {!isGroupsLoading &&
                    !!contratos?.count &&
                    !!grupoeconomico ? (
                      <Stack>
                        {contratos?.results.map(c => (
                          <StrategicMapContracts
                            contrato={c}
                            key={c.id_contrato}
                          />
                        ))}
                        <Flex w="100%" justify="flex-end">
                          <Pagination
                            totalCountOfRegisters={contratos?.count || 0}
                            currentPage={page}
                            onPageChange={e => {
                              setPage(e);
                            }}
                            onPageSizeChange={e => {
                              setPage(1);
                              setPageSize(e.target.value);
                            }}
                            registersPerPage={Number(pageSize)}
                          />
                        </Flex>
                      </Stack>
                    ) : isLoadingContratos ? (
                      <Spinner />
                    ) : (
                      <Text>Nenhum contrato encontrado</Text>
                    )}
                  </Stack>
                </TabPanel>
              )}
            </TabPanels>
          </Tabs>
        )}
      </Stack>
    </Box>
  );
};
